angular.module('core.env', ['environment']);



// WEBPACK FOOTER //
// ./src/app/core/env/env.module.js